<div class="card" *transloco="let t">
  <div class="delete" (click)="delete()">
    <app-svg-icon class="delete-icon" [path]="'/assets/trash.svg'"></app-svg-icon>
  </div>
  <div class="assignment" [ngClass]="{'highlight-for-delete': highlightForDelete}" (touchstart)="start($event)" (mousedown)="start($event)" (touchend)="up($event)" (mouseup)="up($event)" (click)="click()">
    <div class="assignment-first-row">
      <div class="assignment-first-row-status">
        <div *ngIf="audit.state === auditState.Finished" class="submission-date actual">
          <app-svg-icon class="icon" [path]="'/assets/tick.svg'"></app-svg-icon>
          <span>{{ t('MAIN-CARD.STATUS.SUBMITTED') }}</span>
        </div>
        <div *ngIf="audit.state !== auditState.Finished" class="due-date" [ngClass]="{'overdue': isOverdue()}">
          <img *ngIf="isToday()" src="/assets/due_day_icon.svg"/>
          <span>{{ t(displayDueDate()) }}</span>
        </div>
        <div class="frequency">
          <app-svg-icon class="cycle-icon" [path]="'/assets/cycle.svg'"></app-svg-icon>
          <span>{{ t(getPrevalenceKey(audit.frequency)) }}</span>
        </div>
      </div>
      <span class="audit-type" [ngClass]="setClass(audit.type)">
        {{ t('AUDIT-SETUP-PAGE.TYPE-VIEW.AUDIT-TYPES.' + auditType[audit.type].toUpperCase() + '-TITLE') }}
      </span>
    </div>
    <div class="assignment-name">
      <span>{{audit.location}}</span>
      <app-svg-icon class="open-icon" [path]="'/assets/arrow_right.svg'"></app-svg-icon>
    </div>
    <div class="assignment-last-row">
      <span>{{audit.area}}</span>&nbsp;
      <span class="site-and-section">
        {{ audit.site }}{{ audit.site && audit.siteSection ? ', ' : '' }}{{ audit.siteSection }}
      </span>
    </div>
  </div>
</div>
<app-popup [(isOpen)]="popupVisible" [data]="popupData" [dynamicComponent]="dynamicComponent"></app-popup>
